var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 16,
    viewBox: "0 0 50 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_764_15989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0896 0.0246277C28.5941 0.0246277 25.4704 1.8364 25.4704 5.1838C25.4704 9.02263 31.0104 9.28777 31.0104 11.2163C31.0104 12.0283 30.0799 12.7552 28.4905 12.7552C26.2349 12.7552 24.549 11.7395 24.549 11.7395L23.8276 15.1174C23.8276 15.1174 25.7697 15.9754 28.3482 15.9754C32.1698 15.9754 35.177 14.0746 35.177 10.67C35.177 6.61357 29.6139 6.3563 29.6139 4.56631C29.6139 3.93021 30.3778 3.23324 31.9626 3.23324C33.7508 3.23324 35.2097 3.97191 35.2097 3.97191L35.9157 0.709439C35.9157 0.709439 34.3283 0.0246277 32.0896 0.0246277V0.0246277ZM0.109298 0.270852L0.0246582 0.763301C0.0246582 0.763301 1.49521 1.03244 2.81969 1.5693C4.52506 2.18493 4.64654 2.54331 4.93376 3.65644L8.0635 15.7214H12.2589L18.7223 0.270852H14.5365L10.3834 10.7758L8.68868 1.87131C8.53326 0.852201 7.746 0.270852 6.78236 0.270852H0.109298V0.270852ZM20.4055 0.270852L17.1219 15.7214H21.1134L24.3855 0.270852H20.4055V0.270852ZM42.6676 0.270852C41.7051 0.270852 41.1952 0.786158 40.821 1.68664L34.9731 15.7214H39.1589L39.9688 13.3823H45.0683L45.5608 15.7214H49.2541L46.0321 0.270852H42.6676V0.270852ZM43.212 4.44512L44.4528 10.2429H41.1287L43.212 4.44512V4.44512Z",
    fill: "#1434CB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_764_15989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.2788,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default ForwardRef;